import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: ",
        ";\n  background-color: #fff;\n  border-radius: 4px;\n\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: height 0.3s ease-in-out;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  z-index: ",
        ";\n  border-radius: 4px;\n  overflow: hidden;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n\n  transition: top 0.3s ease-in-out, bottom 0.3s ease-in-out, left 0.3s ease-in-out,\n    right 0.3s ease-in-out, z-index 0.3s step-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect } from "react";
import { usePreproductPreviewContext } from "./context/Context";
import styled from "styled-components";
import { Iframe } from "./Iframe";
import { Overlay } from "./Overlay";
import { PREPROD_PREVIEW_ACTIONS } from "./context/types";
import { BackButton } from "./BackButton";
import { useModalTransition } from "./hooks/useModalTransition";
import { useFullscreenListener } from "./hooks/useFullscreenListener";
import { useBoardCreatedListener } from "./hooks/useBoardCreatedListener";
import { fullscreenStatusEvent } from "./context/actions";
var BoardContainer = styled.div.withConfig({
    componentId: "sc-40659e31-0"
})(_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "100%" : 0;
});
var BoardComponent = styled.div.attrs({
    "data-testid": "preproduct-preview-board-container"
}).withConfig({
    componentId: "sc-40659e31-1"
})(_templateObject1(), function(param) {
    var modal = param.modal;
    return modal ? 999 : 0;
});
export var Board = function() {
    var ref = usePreproductPreviewContext(), dispatch = ref.dispatch, boardContainerState = ref.boardContainerState, boardContainerConfig = ref.boardContainerConfig, iframeState = ref.iframeState;
    useFullscreenListener();
    useBoardCreatedListener(boardContainerState.editableTemplates.templateKey);
    var boardRef = useRef(null);
    var ref1 = useModalTransition(boardRef.current, iframeState.iframeRef), openModalTransition = ref1.openModalTransition, closeModalTransition = ref1.closeModalTransition;
    useEffect(function() {
        if (boardContainerState.boardContainerDisplayMode === "inline") {
            fullscreenStatusEvent(iframeState.iframeRef, false);
            closeModalTransition();
        }
        if (boardContainerState.boardContainerDisplayMode === "modal") {
            fullscreenStatusEvent(iframeState.iframeRef, true);
            openModalTransition();
        }
    }, [
        boardContainerState.boardContainerDisplayMode
    ]);
    var isContainerVisible = boardContainerState.boardContainerDisplayMode === "inline" || boardContainerConfig.initialMode === "inline";
    var isModalOpen = boardContainerState.boardContainerDisplayMode === "modal";
    var toggleModal = function(e) {
        e.stopPropagation();
        dispatch({
            type: PREPROD_PREVIEW_ACTIONS.TOGGLE_MODAL
        });
    };
    return /*#__PURE__*/ _jsxs(BoardContainer, {
        isVisible: isContainerVisible,
        children: [
            /*#__PURE__*/ _jsx(Overlay, {
                isVisible: isModalOpen
            }),
            /*#__PURE__*/ _jsxs(BoardComponent, {
                modal: isModalOpen,
                ref: boardRef,
                children: [
                    /*#__PURE__*/ _jsx(Iframe, {
                        templateKey: boardContainerState.editableTemplates.templateKey
                    }),
                    /*#__PURE__*/ _jsx(BackButton, {
                        isVisible: isModalOpen,
                        onClick: toggleModal
                    })
                ]
            })
        ]
    });
};
